import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { CardContent, Collapse } from "@mui/material";
import toast from "react-hot-toast";

import CustomButton from "../../../common/CustomButton";

import { getAge } from "../../../utils/date";
import { GetEmailPrompt, SaveEmailPrompt, GenerateEmail, } from "../../../redux/brg/actions";
import CustomDropDownToggle from "../../../common/CustomDropDownToggle";


function EmailPrompt(props) {
    const [prompt, setPrompt] = useState('');
    const [isOpen, setIsOpen] = useState(true);
    const [temporaryPrompt, setTemporaryPrompt] = useState(null);

    useEffect(() => {
        // props.GetEmailPrompt();
    }, []);

    useEffect(() => {
        if (props.Brg.emailPrompt?.id) {
            setPrompt(props.Brg.emailPrompt?.text);
        }
    }, [props.Brg.emailPrompt?.id])

    const processPrompt = (patient, pPrompt) => {
        // Replace all the placeholders with the actual values

        const sp = props.getSuggestedPrograms(patient?.suggested_programs);

        let processed = pPrompt;
        processed = processed.replace("{patientName}", patient?.first_name + " " + patient?.last_name);
        processed = processed.replace("{patientAge}", getAge(patient?.dob));
        processed = processed.replace("{patientGoals}", `\n - ${patient?.goal_2}\n - ${patient?.goal_3} \n`);
        processed = processed.replace("{subjectiveSummary}", `\n - ${patient?.subjective_summary || "none"} \n`);
        processed = processed.replace("{objectiveSummary}", `\n - ${patient?.objective_summary || "none"} \n`);
        processed = processed.replace("{assessmentSummary}", `\n - ${patient?.assessment_summary || "none"} \n`);
        processed = processed.replace("{planSummary}", `\n - ${patient?.plan_summary || "none"} \n`);

        processed = processed.replace("{programName1}", `${sp[0]?.title?.toUpperCase()}${sp[0]?.level ? (" - " + sp[0]?.level) : ""}\n`);
        processed = processed.replace("{programName2}", `${sp[1]?.title?.toUpperCase()}${sp[1]?.level ? (" - " + sp[1]?.level) : ""}\n`);
        processed = processed.replace("{programName3}", `${sp[2]?.title?.toUpperCase()}${sp[2]?.level ? (" - " + sp[2]?.level) : ""}\n`);

        processed = processed.replace("{program1Description}", `${sp[0]?.info}`);
        processed = processed.replace("{program2Description}", `${sp[1]?.info}`);
        processed = processed.replace("{program3Description}", `${sp[2]?.info}`);

        return processed;
    }

    const savePrompt = async (showPrompt = true) => {
        let tp = prompt;
        if (temporaryPrompt) {
            tp = temporaryPrompt;
            setPrompt(p => tp);
            setTemporaryPrompt(t => null);
        }

        const res = await props.SaveEmailPrompt(props.Brg.emailPrompt?.id, tp);

        if (res) {
            showPrompt && toast.success("Prompt updated!");
        } else {
            showPrompt && toast.error("Failed to update prompt!");
        }

        return tp;
    }

    const handleGenerateEmail = async (pPrompt, toastID) => {
        const processedPrompt = await processPrompt(props?.patient, pPrompt);

        const res = await props.GenerateEmail(processedPrompt, props?.patient?.id);

        if (res.success) {
            toast.success('Email generated!', {
                id: toastID,
            });
        } else {
            toast.error('Failed to generate email!', {
                id: toastID,
            });
        }
    }


    return (
        <>
            <div className="brg-pp brg-pp-email-prompt">
                {/* <CustomDropDownToggle isOpen={isOpen} toggle={() => {
                    setIsOpen(!isOpen);
                }} /> */}

                <h5>
                    Email Prompt
                </h5>
                <Collapse in={isOpen} timeout="auto" unmountOnExit>
                    <div className="brg-pp-em-group">
                        <pre contentEditable={true} onInput={(e) => {
                            setTemporaryPrompt(e.target.outerText);
                        }}>
                            {`${prompt}`}
                        </pre>

                        <div >

                            <CustomButton size="small" isPrimary={false} onClick={() => {
                                savePrompt();
                            }}>
                                SAVE PROMPT
                            </CustomButton>
                        </div>

                    </div>
                </Collapse>

                {/* <div id="generate-email-wrapper">
                    <CustomButton size="small" onClick={async () => {
                        const toastID = toast.loading("Generating email...");
                        const tp = await savePrompt(false);
                        handleGenerateEmail(tp, toastID);
                    }}>
                        GENERATE EMAIL
                    </CustomButton>

                </div> */}
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    Brg: state.Brg
})

export default connect(mapStateToProps, {
    GetEmailPrompt,
    SaveEmailPrompt,
    GenerateEmail,
})(EmailPrompt);
